import { DepositCryptoOption } from 'react-easyrocket';
import { QrCode } from './components/QrCode';
import { InfoText } from './components/QrCode/components/InfoText';

interface InfoBlockProps {
  setIsInfoOpened: (open: boolean) => void;
  selectedCryptoMethod?: DepositCryptoOption;
  isFetchingMissingAddress: boolean;
}

export const InfoBlock = ({
  setIsInfoOpened,
  isFetchingMissingAddress,
  selectedCryptoMethod
}: InfoBlockProps) => {
  return (
    <div className="flex w-full bg-surface-theme-primary p-2.5 rounded-2xl">
      <QrCode
        selectedMethod={selectedCryptoMethod}
        isLoading={isFetchingMissingAddress}
        account={selectedCryptoMethod?.account || ''}
      />
      <InfoText setIsInfoOpened={setIsInfoOpened} selectedCryptoMethod={selectedCryptoMethod} />
    </div>
  );
};
